import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon/Icon';
import { OrderConfiguration, OrderEnum, OrdersTypeEnum } from '../../common/enums';

export const mixedOrderTooltip = (mixOrderConfig) =>
  mixOrderConfig.split(",").map((order) => OrdersTypeEnum[order]).join(", ");

const GRID_LABEL_MAP = (t) => ({
  [OrderConfiguration.Delivery]: t("OrdersTab.delivery"),
  [OrderEnum.Delivery]:          t("OrdersTab.delivery"),
  [OrderConfiguration.Service]:  t("OrdersTab.service"),
  [OrderConfiguration.Supplies]: t("Dashboard.supplies"),
  [OrderConfiguration.PickUp]:   t("OrdersTab.pickup"),
  [OrderEnum.PickUp]:            t("OrdersTab.pickup"),
  [OrderConfiguration.PickUpAll]:t("OrdersTab.pickUpAll"),
});

export const GridOrderType = ({ mixOrderConfig, t }) => {
  if (mixOrderConfig?.includes(",")) {
    return (
      <Tooltip title={mixedOrderTooltip(mixOrderConfig)}>
        <span>{t("OrdersTab.mixed")}</span>
      </Tooltip>
    );
  }
  const label = GRID_LABEL_MAP(t)[mixOrderConfig];
  return label
    ? <Typography component="span" sx={{ color: 'var(--color-dimmergray)' }}>{label}</Typography>
    : null;
};

const ORDER_TYPE_CONFIG = {
  [OrderConfiguration.Delivery]: { icon: 'fa-truck',              color: 'primary',          labelKey: 'OrdersTab.delivery'    },
  [OrderEnum.Delivery]:          { icon: 'fa-truck',              color: 'primary',          labelKey: 'OrdersTab.delivery'    },
  [OrderConfiguration.Service]:  { icon: 'fa-wrench',             color: 'primary',          labelKey: 'OrdersTab.service'     },
  [OrderConfiguration.Supplies]: { icon: 'fa-box',                color: 'primary',          labelKey: 'Dashboard.supplies'    },
  [OrderConfiguration.PickUp]:   { icon: 'fa-dolly',              color: 'success',         labelKey: 'OrdersTab.pickup'      },
  [OrderEnum.PickUp]:            { icon: 'fa-dolly',              color: 'success',         labelKey: 'OrdersTab.pickup'      },
  [OrderConfiguration.PickUpAll]:{ icon: 'fa-cart-flatbed-boxes', color: 'success',         labelKey: 'OrdersTab.pickUpAll'   },
};


const OrderType = ({ mixOrderConfiguration }) => {
  const { t } = useTranslation();

  if (mixOrderConfiguration?.includes(",")) {
    return (
      <Box data-testid="OrderType">
        <Tooltip title={mixedOrderTooltip(mixOrderConfiguration)}>
          <Stack direction="column" alignItems="center" spacing={0.75}>
            <Icon icon="fa-kit fa-truck-arrow-right-arrow-left" color="primary" size='md' />
            <Typography color="text.secondary" fontWeight="medium" component="span">{t("OrdersTab.mixed")}</Typography>
          </Stack>
        </Tooltip>
      </Box>
    );
  }

  const config = ORDER_TYPE_CONFIG[mixOrderConfiguration];
  if (!config) return null;

  return (
    <Box data-testid="OrderType">
      <Stack direction="column" alignItems="center" spacing={0.75}>
        <Icon icon={config.icon} color={config.color} size='md' />
        <Typography color="text.secondary" fontWeight="medium" component="span">{t(config.labelKey)}</Typography>
      </Stack>
    </Box>
  );
};

export default OrderType;
